import React, { useState, useEffect, useContext } from 'react';
import { AstroChartComponent } from './AstroChart';
import { getAstrology, getPlanetHouse, formatDegrees } from './utilsAstro';
import { useLocation, useNavigate } from 'react-router-dom';
import { PlanetIco } from '../UiKit/Planets';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { LangContext } from '../../contexts/langContext';
import { astro_dictionary, astroElements, astroInfo, astroSvgs } from '../../static/astro';
import '../../components/css/astro.css';
import { Icon } from '../UiKit/Icon';
import { Planet } from '../UiKit/Planet';
import { Button } from '../UiKit/Button';
import { Svg } from '../UiKit/Svg';
import { AstroSign } from '../UiKit/AstroSign';
import { AstroSummary } from './AstroSummary';
import { ensureAvatarCity } from '../utilsGeo';



export const getElementColor = (sign) => {
  return astroElements[astroInfo[sign]?.element] || 'transparent';
}


export function Astro({ avatar, handleClick }) {
  // console.log('avatar.astro = ', avatar.astro);
  const [horoscope, setHoroscope] = useState();
  const [loading, setLoading] = useState(!avatar.astro);
  const [error, setError] = useState(null);
  const [dobAstro, setDobAstro] = useState({});

  useEffect(() => {
    if (!avatar?.dob || !avatar?.aggr?.city) {
      setHoroscope(undefined);
      setLoading(false);
      setError(null);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const { horoscope: horoscopeInstance, origin } = getAstrology(avatar);
      setDobAstro(origin);
      setHoroscope(horoscopeInstance);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [avatar?.dob, avatar?.aggr?.city]);

  const location = useLocation();
  const navigate = useNavigate();

  const context = { ...useContext(LangContext) };
  const $ui = context.$ui;
  const celestialPointsAllA = horoscope?.CelestialPoints?.all || [];
  const trueNorthNodeA = celestialPointsAllA.find(p => p?.key === 'northnode' || (p?.label || '').toLowerCase() === 'north node');
  const trueSouthNodeA = celestialPointsAllA.find(p => p?.key === 'southnode' || (p?.label || '').toLowerCase() === 'south node');
  const getSignLabelFromDegreeA = (decimal) => {
    const signs = ['Aries','Taurus','Gemini','Cancer','Leo','Virgo','Libra','Scorpio','Sagittarius','Capricorn','Aquarius','Pisces'];
    if (typeof decimal !== 'number' || isNaN(decimal)) return '';
    const norm = ((decimal % 360) + 360) % 360;
    const index = Math.floor(norm / 30) % 12;
    return signs[index];
  };
  const southFromTrueA = (!trueSouthNodeA && trueNorthNodeA) ? (() => {
    const deg = (trueNorthNodeA?.ChartPosition?.Ecliptic?.DecimalDegrees + 180) % 360;
    return {
      Sign: { label: getSignLabelFromDegreeA(deg) },
    };
  })() : null;
  

  // useEffect(() => {
  //   if (!horoscope) {
  //     try {
  //         const { horoscope: horoscopeInstance, origin } = getAstrology(avatar);
  //         setDobAstro(origin);
  //         // console.log('origin = ', origin);
  //         // console.log('horoscopeInstance = ', horoscopeInstance);
  //         setHoroscope(horoscopeInstance);
  //         setLoading(false);
  //       } catch (err) {
  //         setError(err.message);
  //         setLoading(false);
  //       }
  //     }
  // }, [avatar]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!horoscope) {
    return <div></div>;
  }


  // const handleClick = () => {
  //   let newPath = location.pathname.split('/study')[0];
  //   newPath = newPath.slice(-1) === '/' ? newPath + `study/astro` : newPath + `/study/astro`
  //   const queryParams = location.search ? location.search : '';
  //   navigate(`${newPath}${queryParams}`);
  // };


  return (
    <>
      <div className="x_edu_astronumero_section" onClick={typeof handleClick === 'function' ? () => handleClick('astro') : void(0)}>
        <div className="x_edu_circle0">
          <div className="x_edu_circle"
            style={{
              background: `linear-gradient(to bottom, ${getElementColor(horoscope.SunSign?.label)} 0%, ${getElementColor(horoscope.SunSign?.label)} 50%, ${getElementColor(horoscope.Ascendant?.Sign?.label)} 78%, ${getElementColor(horoscope.Ascendant?.Sign?.label)} 100%)`,
              boxShadow: `inset 0 0 4px 1px ${getElementColor(horoscope.SunSign?.label)}`
            }}
          >
            <Svg width={24} height={24}>{astroInfo[horoscope.SunSign?.label]?.svg}</Svg>
            {/* <Svg>{astro_dictionary['taurus'].svg}</Svg> */}
            {/* <Svg>{astroSvgs['Aries']}</Svg> */}
          </div>
        </div>
        <div className="x_edu_astro">
          <div className="_fm _fgap02"><PlanetIco planet={'Sun'} /> <strong>{$ui(horoscope.SunSign?.label) || '–'}</strong></div>
            <div className="_fm _fgap02"><Svg width={14} height={14}>{astroSvgs['asc']}</Svg><strong>{$ui(horoscope.Ascendant?.Sign?.label) || '–'}</strong></div>
          {/* <div className="f">
            <div className="_fc _fgap02">MC<strong>{$ui(horoscope.Midheaven?.Sign?.label) || '–'}</strong></div>
          </div> */}

          { (trueNorthNodeA || trueSouthNodeA) && <div className="f">
            <div className="_fc _fgap02"><PlanetIco planet={'North_Node'} /> <strong>{$ui(trueNorthNodeA?.Sign?.label) || '–'}</strong></div>
          </div> }
          { (trueNorthNodeA || trueSouthNodeA) && <div className="f">
            <div className="_fc _fgap02"><PlanetIco planet={'South_Node'} /> <strong>{$ui((trueSouthNodeA || southFromTrueA)?.Sign?.label) || '–'}</strong></div>
          </div> }


        </div>
      </div>              
    </>
  );
}


export const AstroSocial = React.memo(({ avatar, handleClick }) => {
  // console.log('avatar.astro = ', avatar.astro);
  const [horoscope, setHoroscope] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dobAstro, setDobAstro] = useState({});

  const location = useLocation();
  const navigate = useNavigate();

  const context = { ...useContext(LangContext) };
  const $ui = context.$ui;
  
 
  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      if (!avatar?.dob && !avatar?.design?.meta?.personality) {
        if (!cancelled) {
          setHoroscope(null);
          setLoading(false);
          setError(null);
        }
        return;
      }

      if (!cancelled) {
        setLoading(true);
        setError(null);
      }

      try {
        // Penta members often have city_id but empty aggr — same path as PentaAstro.
        const avatarWithCity = await ensureAvatarCity(avatar);
        if (cancelled) return;
        if (!avatarWithCity?.aggr?.city?.location) {
          setHoroscope(null);
          return;
        }
        const result = getAstrology(avatarWithCity);
        setHoroscope(result?.horoscope || null);
      } catch (err) {
        if (!cancelled) setError(err.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    run();
    return () => { cancelled = true; };
  }, [avatar?.dob, avatar?.city_id, avatar?.aggr?.city?.location]);

  if (loading) {
    return <div className="x_social_astro"
    // style={{
    //   background: 'transparent'
    // }}
  >
      <div className="_f _fgap02" style={{color: '#ccdaf8'}}>
        <Icon size={'lg'}>question_mark</Icon>
      </div>
      {/* <div className="_f _t08" style={{marginTop: '0.4em', marginBottom: '-0.4em'}}>
        <div className="_fc _fgap02">—</div>
      </div> */}
  </div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!horoscope) {
    return (
      <div className="x_social_astro" aria-hidden="true">
        <div className="_f _fgap02" style={{ visibility: 'hidden' }}>
          <Svg width={16} height={16} />
          <strong>&nbsp;</strong>
        </div>
        <div className="_f _t08" style={{ marginTop: '0.4em', marginBottom: '-0.4em', visibility: 'hidden' }}>
          <div className="_fc _fgap02">
            <Svg width={16} height={16} />
            <strong>&nbsp;</strong>
          </div>
        </div>
      </div>
    );
  }



  return (
        <>


        {Boolean(avatar.dob) && <div className="x_social_astro"
          style={{
            background: `linear-gradient(to bottom, ${getElementColor(horoscope.SunSign?.label)} 0%, ${getElementColor(horoscope.SunSign?.label)} 56%, ${getElementColor(horoscope.Ascendant?.Sign?.label)} 72%, ${getElementColor(horoscope.Ascendant?.Sign?.label)} 100%)`,
            boxShadow: `0 1px 0px 0px hsla(0, 0.00%, 0.00%, 0.13), inset 0 0 4px 0px ${getElementColor(horoscope.SunSign?.label)}`
          }}
        >

            <div className="_f _fgap02">
              <Svg width={16} height={16}>{astroInfo[horoscope.SunSign?.label]?.svg}</Svg> <strong>{$ui(horoscope.SunSign?.label) || '–'}</strong>
            </div>
            <div className="_f _t08" style={{marginTop: '0.4em', marginBottom: '-0.4em'}}>
              <div className="_fc _fgap02">
                <Svg width={16} height={16}>{astroSvgs['asc']}</Svg>
                <strong>{$ui(horoscope.Ascendant?.Sign?.label) || '–'}</strong></div>
            </div>
            {/* <div className="_f">
              <div className="_fc _fgap02">MC<strong>{$ui(horoscope.Midheaven?.Sign?.label) || '–'}</strong></div>
            </div> */}

        </div>}



              
        </>
  );
});



export function AstroInfo({ avatar }) {
  // console.log('avatar.astro = ', avatar.astro);
  const [horoscope, setHoroscope] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dobAstro, setDobAstro] = useState({});

  useEffect(() => {
    if (!avatar?.dob || !avatar?.aggr?.city) {
      setHoroscope(null);
      setLoading(false);
      setError(null);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const { horoscope: horoscopeInstance, origin } = getAstrology(avatar);
      setDobAstro(origin);
      setHoroscope(horoscopeInstance);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [avatar?.dob, avatar?.aggr?.city]);

  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui;

  const celestialPointsAll = horoscope?.CelestialPoints?.all || [];
  const trueNorthNode = celestialPointsAll.find(p => p?.key === 'northnode' || (p?.label || '').toLowerCase() === 'north node');
  const trueSouthNode = celestialPointsAll.find(p => p?.key === 'southnode' || (p?.label || '').toLowerCase() === 'south node');
  // const meanNorthNode = celestialPointsAll.find(p => p?.key === 'meannode' || (p?.label || '').toLowerCase() === 'mean node');
  // const meanSouthNode = celestialPointsAll.find(p => p?.key === 'meansouthnode' || (p?.label || '').toLowerCase() === 'mean south node');

  const getSignLabelFromDegree = (decimal) => {
    const signs = ['Aries','Taurus','Gemini','Cancer','Leo','Virgo','Libra','Scorpio','Sagittarius','Capricorn','Aquarius','Pisces'];
    if (typeof decimal !== 'number' || isNaN(decimal)) return '';
    const norm = ((decimal % 360) + 360) % 360;
    const index = Math.floor(norm / 30) % 12;
    return signs[index];
  };

  const formatDecimalArc30 = (decimal) => {
    if (typeof decimal !== 'number' || isNaN(decimal)) return '';
    const norm = ((decimal % 360) + 360) % 360;
    const degWithin = norm % 30;
    const degInt = Math.floor(degWithin);
    const minutes = Math.round((degWithin - degInt) * 60);
    return `${degInt}° ${String(minutes).padStart(2,'0')}'`;
  };

  const southFromTrue = (!trueSouthNode && trueNorthNode) ? (() => {
    const deg = (trueNorthNode?.ChartPosition?.Ecliptic?.DecimalDegrees + 180) % 360;
    return {
      Sign: { label: getSignLabelFromDegree(deg) },
      ChartPosition: { Ecliptic: { DecimalDegrees: deg, ArcDegreesFormatted30: formatDecimalArc30(deg) } }
    };
  })() : null;


  const planetName = (name) => {
    console.log('name = ', name);
    switch (name) {
      case 'North Node':
        return 'North_Node';
      case 'South Node':
        return 'South_Node';
      default:
        return name;
    }
  }

  if (loading) {
    return <div>Loading astrology chart3...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!horoscope) {
    return <div></div>;
  }

  return (
    <div className="astro-chart">



      {/* <div className="x_info_w"> */}
        {/* <div className="x_info_title">
          <div className="x_info_title_text">
            <div className="x_edu_channel_h1">
          {$ui('popinfo_astro_title')}
            </div>
          </div>
        </div> */}
        {/* <div className="x_edu_authority ">
              {$ui('popinfo_beta')}
            </div> */}
      {/* </div> */}




      <div className="_fv _fgap1">
        <div className="chart-visualization _fv _fcc">
          <AstroChartComponent horoscope={horoscope} size={360} />

          {/* <pre>
            {JSON.stringify({
              ...dobAstro,
              timezone: {
              ...dobAstro.timezone,
              abbrs: 'UTC',
              untils: 'UTC',
              offsets: '',
              },
              untils: 'UTC'
            }, null, 2)}
          </pre> */}

        </div>
        <div className="x_info_w _fv">





              <AstroSummary horoscope={horoscope} />

          <div className="_fv _fgap0 _f100">
            <h4>{$ui('astro_planets')}</h4>
            <div className="astro-table">
              <div className="astro-table-header">
                <div className="astro-table-cell"></div>
                <div className="astro-table-cell">{$ui('astro_planet')}</div>
                <div className="astro-table-cell">{$ui('astro_sign')}</div>
                <div className="astro-table-cell">{$ui('astro_degree')}</div>
                <div className="astro-table-cell">{$ui('astro_house')}</div>
              </div>
              {horoscope.CelestialBodies?.all?.map((planet, index) => (
                <div key={index} className="astro-table-row">
                  <div className="astro-table-cell"><PlanetIco planet={planetName(planet?.label)} /></div>
                  <div className="astro-table-cell"><b>{$ui(`planet_${planet?.label}`)}</b></div>
                  {/* <div className="astro-table-cell"><Planet
                    planet={planet?.label}
                    shown={true}
                    titleShownLong={true}
                    glyph={true}
                    name={true}
                  /></div> */}
                  <div className="astro-table-cell" 
                    style={{
                      backgroundColor: getElementColor(planet?.Sign?.label)
                    }}
                  > <div className="_f _fgap04 _fm"><AstroSign size={12} sign={planet?.Sign?.label} /> {$ui(planet?.Sign?.label) || 'N/A'}</div></div>
                  <div className="astro-table-cell">{formatDegrees(planet?.ChartPosition?.Ecliptic?.ArcDegreesFormatted30) || ''}</div>
                  <div className="astro-table-cell">{getPlanetHouse(planet, horoscope.Houses)}</div>
                </div>
              )) || <div className="astro-table-row"><div className="astro-table-cell" style={{gridColumn: '1 / -1'}}>No planet data available</div></div>}

              {/* True Node (North Node) */}
              {trueNorthNode && <div className="astro-table-row">
                <div className="astro-table-cell"><PlanetIco planet={planetName(trueNorthNode?.label)} /></div>
                <div className="astro-table-cell"><b>{$ui('planet_North_Node')}</b></div>
                <div className="astro-table-cell"
                  style={{
                    backgroundColor: getElementColor(trueNorthNode?.Sign?.label)
                  }}
                ><div className="_f _fgap04 _fm"><AstroSign size={12} sign={trueNorthNode?.Sign?.label} />{$ui(trueNorthNode?.Sign?.label) || 'N/A'}</div></div>
                <div className="astro-table-cell">{formatDegrees(trueNorthNode?.ChartPosition?.Ecliptic?.ArcDegreesFormatted30) || ''}</div>
                <div className="astro-table-cell">{getPlanetHouse(trueNorthNode, horoscope.Houses)}</div>
              </div>}

              {/* South Node: from library if present; otherwise opposite point of True Node */}
              {(trueSouthNode || trueNorthNode) && <div className="astro-table-row">
                <div className="astro-table-cell"><PlanetIco planet={planetName(trueSouthNode?.label)} /></div>
                <div className="astro-table-cell"><b>{$ui('planet_South_Node')}</b></div>
                <div className="astro-table-cell"
                  style={{
                    backgroundColor: getElementColor((trueSouthNode || southFromTrue || trueNorthNode)?.Sign?.label)
                  }}
                ><div className="_f _fgap04 _fm"><AstroSign size={12} sign={(trueSouthNode || southFromTrue || trueNorthNode)?.Sign?.label} />{$ui((trueSouthNode || southFromTrue || trueNorthNode)?.Sign?.label) || 'N/A'}</div></div>
                <div className="astro-table-cell">{formatDegrees((trueSouthNode || southFromTrue || trueNorthNode)?.ChartPosition?.Ecliptic?.ArcDegreesFormatted30) || ''} {/* opposite of NN */}</div>
                <div className="astro-table-cell">{getPlanetHouse((trueSouthNode || southFromTrue || trueNorthNode), horoscope.Houses)}</div>
              </div>}
            </div>
          </div>
          <div className="houses">
            <h4>{$ui('astro_house_cusps')} (Placidus)</h4>
            <div className="_f _fwrap _fgap1 ">
              {horoscope.Houses?.map((house, index) => (
                <div key={index} className="house">
                  <strong>{$ui('astro_house')} {index + 1}:</strong> {$ui(house?.Sign?.label) || 'N/A'} {formatDegrees(house?.ChartPosition?.Horizon?.ArcDegreesFormatted) || ''}
                </div>
              )) || <p>No house data available</p>}
            </div>
          </div>
          <p/>

          {/* <div className="aspects">
            <h4>Major Aspects</h4>
            {horoscope.Aspects?.types?.conjunction?.map((aspect, index) => (
              <div key={index} className="aspect">
                <strong>{aspect?.point1?.label || aspect?.point1?.key || 'Unknown'} {aspect?.type || 'aspect'} {aspect?.point2?.label || aspect?.point2?.key || 'Unknown'}:</strong> {aspect?.orb || 'N/A'}° orb
              </div>
            ))}
            {horoscope.Aspects?.types?.opposition?.map((aspect, index) => (
              <div key={index} className="aspect">
                <strong>{aspect?.point1?.label || aspect?.point1?.key || 'Unknown'} {aspect?.type || 'aspect'} {aspect?.point2?.label || aspect?.point2?.key || 'Unknown'}:</strong> {aspect?.orb || 'N/A'}° orb
              </div>
            ))}
            {horoscope.Aspects?.types?.trine?.map((aspect, index) => (
              <div key={index} className="aspect">
                <strong>{aspect?.point1?.label || aspect?.point1?.key || 'Unknown'} {aspect?.type || 'aspect'} {aspect?.point2?.label || aspect?.point2?.key || 'Unknown'}:</strong> {aspect?.orb || 'N/A'}° orb
              </div>
            ))}
            {horoscope.Aspects?.types?.square?.map((aspect, index) => (
              <div key={index} className="aspect">
                <strong>{aspect?.point1?.label || aspect?.point1?.key || 'Unknown'} {aspect?.type || 'aspect'} {aspect?.point2?.label || aspect?.point2?.key || 'Unknown'}:</strong> {aspect?.orb || 'N/A'}° orb
              </div>
            ))}
            {(!horoscope.Aspects?.types?.conjunction?.length && 
              !horoscope.Aspects?.types?.opposition?.length && 
              !horoscope.Aspects?.types?.trine?.length && 
              !horoscope.Aspects?.types?.square?.length) && 
              <p>No major aspects found</p>}
          </div> */}
          {/* <details>
            <summary>Raw Horoscope Data</summary>
            <pre>{JSON.stringify(horoscope, null, 2)}</pre>
          </details> */}
        </div>
      </div>



    </div>
  );
} 